module.exports = __webpack_public_path__ + "img/pro_feature_packing_list.9e52b7b.png";